import { useEffect } from 'react';

export function useWindowEventWithFlag(eventName, handler, flag) {
  useEffect(() => {
    if (!flag) return;

    setTimeout(() => window.addEventListener(eventName, handler), 0);

    return () => window.removeEventListener(eventName, handler);
  }, [eventName, handler, flag]);
}
